(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faqs-select"]) return;
  try {
    
  $('.faqs-selectors .faqs-select').click(function(e) {
    let index = $(this).attr('id').split("-").pop();
    $('.faqs-selectors .faqs-select').removeClass('active');
    $(this).addClass('active');
    $('.faqs-panel').removeClass('active');
    $('.faqs-container.index-' + index).closest('.faqs-panel').addClass('active');
  });

  $(document).ready(function(){
    $('.faqs-selectors').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1279,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faqs-tab"]) return;
  try {
    

  $('.subsection .subheading').click(function(e) {
    if ($(this).parent().hasClass('active')) {
      $(this).parent().removeClass('active');
    } else {
      $('.subsection.active').removeClass('active');
      $(this).parent().addClass('active');
    }
    $('.subsection.active').children('.faqs-item').slideDown();
    $('.subsection:not(.active)').children('.faqs-item').slideUp();
  });


  $('.faqs-item').click(function(e) {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).children('.answer').first().slideUp();
    } else {
      $('.faqs-item.active').children('.answer').first().slideUp();
      $('.faqs-item.active').removeClass('active');
      $(this).addClass('active');
      $(this).children('.answer').first().slideDown();
    }
  });
  $( document ).ready(function(){
    $('.faqs-panel').first().addClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-trade-tabs"]) return;
  try {
    
  $(document).ready(function () {
    $('.trade-carousel').hide().first().show().addClass('active');
    $('.switches-sockets-landing-link').click(function () {
      var $this = $(this);
      var $siblings = $this.parent().children();
      var position = $siblings.index($this);
      $('.trade-carousel').removeClass('active').hide().eq(position).fadeIn().addClass('active');
      $siblings.removeClass('active');
      $this.addClass('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rich-media"]) return;
  try {
    

  $( document ).ready(function() {

      $('.in-box-3-popout-video > .box-container').on("click", function(event) {
        $('#rich-media-popup').show();
        let container = event.target.closest(".box-container");
        if (screen.width < 768) {
          $('#rich-media-popup .video-section').html('<iframe src="' + container.dataset.videomobile + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe><div class="video-section-popup"><span>' + theme.strings.close + ' X</span></div>');
        } else {
          $('#rich-media-popup .video-section').html('<iframe src="' + container.dataset.video + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe><div class="video-section-popup"><span>' + theme.strings.close + ' X</span></div>');
        }

        $('.video-section-popup').on("click", function(event) {
          $('#rich-media-popup').hide();
        });
      });

    $('.video-section-backdrop').on("click", function(event) {
      $('#rich-media-popup').hide();
    });
    
    $('.video-section-popup').on("click", function(event) {
      $('#rich-media-popup').hide();
    });

    $("input.slider").on("input change", function(event) {
      var element = $(this).parents("div.before-after-container");
      var pos = event.target.value;

      if ((window.innerWidth > 767) && (pos > 60)) {
        event.target.value = pos = 60;
      }

      element.find("div.before").css({width: pos + "%"});
      element.find("div.slider-button").css({left: "calc(" + pos + "% - 18px)"});
    });

    $(window).on("scroll", function() {
      var slider = $("input.slider");
      if (slider.length) {
        var sliderPosition = slider.offset().top;
        var sliderHeight = slider.outerHeight();
        var viewportHeight = $(window).height();
        var scrollTop = $(this).scrollTop();

        var scrollThreshold = 0; // Adjust this value as needed
        var sliderOffset = /Mobi|Android/i.test(navigator.userAgent) ? 400 : 50; // Adjust this value as needed

        if (sliderPosition >= scrollTop - scrollThreshold - sliderOffset && sliderPosition <= scrollTop + viewportHeight - sliderHeight + scrollThreshold + sliderOffset) {
          var sliderValue = Math.round((sliderPosition - scrollTop + scrollThreshold + sliderOffset) * 160 / (viewportHeight - sliderHeight + (scrollThreshold + sliderOffset) * 2));
          slider.val(160 - sliderValue).trigger("input");
          slider.parents("div.before-after-container").find("div.slider-button").css({left: "calc(" + (100 - sliderValue) + "% - 18px)"});
        } else {
          if (scrollTop < sliderPosition - scrollThreshold - sliderOffset) {
            slider.val(0).trigger("input");
            slider.parents("div.before-after-container").find("div.slider-button").css({left: "0"});
          } else {
            slider.val(160).trigger("input");
            slider.parents("div.before-after-container").find("div.slider-button").css({left: "calc(100% - 18px)"});
          }
        }
      }
    });

    $('.carousel-container').slick({
      centerPadding: '60px',
      slidesToShow: 3.5,
      initialSlide: 0,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            centerPadding: '40px',
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerPadding: '40px',
            slidesToShow: 1.5
          }
        }
      ]
    });

    $('.carousel-item.slick-slide').on("click", function(event){
      let targetSlide = $(this).data("slick-index");
      $('.carousel-container').slick('slickGoTo',targetSlide);
    });

    $('.box-2-video-image-left').on("click", function(event) {

      $('#rich-media-popup').show();
      let container = event.target.closest(".box-2-video-image-left");
      if (screen.width < 768) {
        $('#rich-media-popup .video-section').html('<iframe src="' + container.dataset.videomobile + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe><div class="video-section-popup"><span>' + theme.strings.close + ' X</span></div>');
      } else {
        $('#rich-media-popup .video-section').html('<iframe src="' + container.dataset.video + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe><div class="video-section-popup"><span>' + theme.strings.close + ' X</span></div>');
      }

      $('.video-section-popup').on("click", function(event) {
        $('#rich-media-popup').hide();
      });

    });
    
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-carousel-with-header"]) return;
  try {
    
  $(document).ready(function() {
    $('.carousel').on('scroll', function() {
      $this = $(this);
      var scrollLeft = $this.scrollLeft();
      var scrollWidth = this.scrollWidth;
      var clientWidth = this.clientWidth;
      var scrollbarValue = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      var scrollbar = $this.parent().parent().next('.scrollbar-container').find('.carousel-scrollbar');

      scrollbar.val(scrollbarValue);
    });

    $(document).on('input', '.carousel-scrollbar', function() {
      $this = $(this);
      var overflowContainer = $this.closest('.scrollbar-container').prev('.carousel-wrapper').find('.carousel');
      var scrollWidth = overflowContainer.prop('scrollWidth');
      var clientWidth = overflowContainer.width();
      var scrollLeft = ($this.val() / 100) * (scrollWidth - clientWidth);

      overflowContainer.scrollLeft(scrollLeft);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-cookie-type"]) return;
  try {
    
  $(document).ready(function(){

    $('.section-heading').on('click', function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).siblings('.cookie-list').slideUp();
      } else {
        $(this).addClass('active');
        $(this).siblings('.cookie-list').slideDown();
      }
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-links"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  var carousel = document.getElementById('carousel');
  var scrollLeftButton = document.getElementById('scroll-left');
  var scrollRightButton = document.getElementById('scroll-right');

  scrollLeftButton.addEventListener('click', function() {
      carousel.scrollTo({
        left: carousel.scrollLeft - 100, // Adjust the value as needed
        behavior: 'smooth'
      });
  });

  scrollRightButton.addEventListener('click', function() {
      carousel.scrollTo({
        left: carousel.scrollLeft + 100, // Adjust the value as needed
        behavior: 'smooth'
      });
  });
  });

  } catch(e) { console.error(e); }
})();
})();
